// components/Profile/FacilitiesTab.jsx
import { Card, Col, Empty, Row, Typography, Tag } from "antd";

const { Title, Text } = Typography;

const FacilitiesTab = ({ institution }) => {
  const facilities = institution?.facilities || [];

  if (facilities.length === 0) {
    return (
      <Empty
        description="No specialized facilities found for this institution."
        className="my-12"
      />
    );
  }

  return (
    <div className="pt-5 pb-6">
      <Row gutter={[24, 24]}>
        {facilities.map((facility) => (
          <Col key={facility.id} xs={24} sm={12} md={6}>
            <Card
              title={
                <div className="text-base font-semibold text-gray-800">
                  {facility.name}
                </div>
              }
              className="hover:shadow transition-all"
              bordered
            >
              <div className="text-sm text-gray-700 space-y-2">
                <p>
                  <strong>Description:</strong>{" "}
                  {facility.description || (
                    <span className="text-gray-400">N/A</span>
                  )}
                </p>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default FacilitiesTab;
